module.exports = __webpack_public_path__ + "static/img/46.5f3af8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/news/gallery/16/46.jpg
// module id = 707
// module chunks = 0